import {KeycloakService} from 'keycloak-angular';
import { environment } from '../../environments/environment';
import { AccountService } from '../services/account.service';
import { ParametersService } from '../services/parameters.service';
import { TranslateService } from '@ngx-translate/core';

/**
 * Log in by calling keycloak service
 * Loads user roles
 * Loads parameters
 * @param keycloak
 * @param accountService
 */
export function initializer(
  keycloak: KeycloakService,
  accountService: AccountService,
  parameterService: ParametersService,
  translateService: TranslateService): () => Promise<any> {
  return (): Promise<any> => {
    return new Promise(async (resolve, reject) => {
      try {
        // keycloak initialization
        await keycloak.init({
          config: {
            url: environment.serverUrl + 'auth',
            realm: 'noval',
            clientId: 'vls'
          },
          initOptions: {
            onLoad: 'login-required',
            checkLoginIframe: false
          },
          bearerExcludedUrls: [],
        });

        // loading user roles and locale
        await accountService.getRoles();
        await accountService.getLocale()
                            .then( val => translateService.use(val.toLowerCase()))
                            .catch(err => translateService.use(environment.defaultLanguage));


        // loading parameters
        await parameterService.getDashboardRefreshInterval().catch(err => console.error(err.message));
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  };
}



// WEBPACK FOOTER //
// ./src/app/utils/app-init.ts